import { INCOMING_ACTIVITY } from 'botframework-webchat-core/lib/actions/incomingActivity';
import { sendEvent } from 'botframework-webchat-core';
import { AppEventType, MessageEvent, AppIntentType } from '@sa/cassius-contract';
import { STORE_ACTION_TYPES } from '../eventTypes/storeActions';
import { sendMessageToApp } from '../hostInteractions/hostInteractions';
import { createAnyAppEvent } from './app-events';

const CHANNEL_SWAP_EVENT: AppEventType = 'channelSwap';
const APP_MESSAGE_EVENT: MessageEvent = 'webchat/intent';
const CHANNEL_SWAP_TIMEOUT_INTENT: AppIntentType = 'channelSwapTimeout';
const CHANNEL_SWAP_TOKEN_INTENT: AppIntentType = 'channelSwapSecurityToken';
const DEFAULT_TIMEOUT_MS = 30 * 1000; // 30 seconds

/**
 * Is the store action an outgoing request for the app to respond with a channel swap security token?
 * @param action
 */
function isOutgoingChannelSwapRequest(action) {
  return action.type === INCOMING_ACTIVITY && action.payload?.activity?.value?.type === CHANNEL_SWAP_EVENT;
}

/**
 * Is the store action an incoming response from the app with a channel swap security token?
 * @param action
 */
function isIncomingChannelSwapToken(action) {
  return (
    STORE_ACTION_TYPES.includes(action.type) &&
    action.payload?.type === APP_MESSAGE_EVENT &&
    action.payload?.data?.intent === CHANNEL_SWAP_TOKEN_INTENT
  );
}

/**
 * Middleware that sends a timeout event to the bot if the app does not respond to a channel swap request within a certain amount of time.
 * @param channelSwapTimeoutMS
 */
export const channelSwapHandlerMiddleware = (channelSwapTimeoutMS: number = DEFAULT_TIMEOUT_MS) => {
  let timer;
  return ({ dispatch }) => (next) => (action) => {
    if (isOutgoingChannelSwapRequest(action) && timer === undefined) {
      sendMessageToApp(createAnyAppEvent(action.payload.activity.value));
      timer = setTimeout(() => {
        dispatch(sendEvent(APP_MESSAGE_EVENT, { intent: CHANNEL_SWAP_TIMEOUT_INTENT }));
      }, channelSwapTimeoutMS);
    } else if (isIncomingChannelSwapToken(action) && timer !== undefined) {
      clearTimeout(timer);
      timer = undefined;
    }
    return next(action);
  };
};
